<template>
  <div class="table">
    <el-table :data="itemList"  stripe  style="width: 100%">
      <el-table-column prop="customer_sku" label="货号">
        <!-- <span>{{sku_code}}</span> -->
      </el-table-column>
      <el-table-column prop="spec" label="规格"></el-table-column>
      <el-table-column prop="delivery" label="货期">
        <span slot-scope="scope">{{scope.row.stock > 0 ? '现货' : scope.row.delivery}}</span>
      </el-table-column>
      <el-table-column prop="price" label="单价(元)">
        <td class="newPrice" slot-scope="scope">
          <div>
            <span class="old">￥{{scope.row.original_price}}</span>
            <span class="new">￥{{scope.row.discount_price}}</span>
          </div>
          <!-- <span v-if="scope.row.is_discount == 0">￥{{ scope.row.price }}</span> -->
        </td>
      </el-table-column>
      <el-table-column prop="num" label="数量" width="150">
        <div class="btns" slot-scope="scope">
          <button class="sub" @click="sub(scope.row)">-</button>
          <input type="text" class="num" v-model="scope.row.num" />
          <button class="add" @click="add(scope.row)">+</button>
        </div>
      </el-table-column>
      <el-table-column prop="11" label="操作">
        <button
          slot-scope="scope"
          class="addcar"
          @click="addShopCar(scope.row.sku_id, scope.row.num)"
        >
          <Icon type="md-cart" size="20" />
        </button>
      </el-table-column>
      <div slot="empty" style="height: 300px; line-height: 250px">
        暂无数据
        <span
          style="
                  color: #ffbb00;
                  cursor: pointer;
                  text-decoration: underline;
                "
          @click="
                  () => {
                    this.$router.push('/productCenter');
                  }
                "
        >去逛逛</span>
      </div>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ["itemList", "name", "brand", "sku_code"],
  data() {
    return {
      num: 0,
      IsToken: localStorage.getItem("token")
        ? localStorage.getItem("token")
        : ""
    };
  },
  methods: {
    add(item) {
      item.num++;
    },
    sub(item) {
      if (item.num > 1) {
        item.num--;
      } else {
        item.num = 1;
      }
    },
    addShopCar(id, num) {
      //加入购物车接口
      this.$api.shopCar
        .addcar({
          sku_id: id,
          num: num
        })
        .then(res => {
          this.$message.closeAll();
          this.$message({
            message: "已成功加入购物车",
            type: "success"
          });
        });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-table th, .el-table tr {
  background: #f5f5f5;
   color:#000;
}
/deep/.el-table__row{
  color:#000;
  font-size:16px;
}
.newPrice {
  .old {
    text-decoration: line-through;
    display: block;
  }
  .new {
    color: #a52a2a;
  }
}
.btns {
  left: 772px;
  top: 12px;
  width: 65px;
  height: 16px;
  display: flex;
  justify-content: space-around;
  button {
    border: 0px;
    background: #fff;
    line-height: 16px;
  }
  input {
    border: 0px;
    width: 40px;
    height: 100%;
    text-align: center;
  }
}
.addcar {
  border: 0px;
  background: #fff;
  color: #a52a2a;
}
</style>